export enum RouteVisitStatus {
    Planned,
    Next,
    Arrived,
    Departed,
    Missed,
    Cancelled
}
